import { Component, input, output } from '@angular/core';
import { WarningConfirmDialog } from '../../../../shared/components/warning-confirm-dialog/warning-confirm-dialog';

/**
 * Warning dialog shown before Edit navigates away from Review & Pay.
 */
@Component({
  selector: 'app-review-edit-warning-dialog',
  imports: [WarningConfirmDialog],
  template: `
    <app-warning-confirm-dialog
      [open]="open()"
      modalClass="review-edit-warning-dialog"
      titleKey="createShipment.reviewAndPay.editWarning.title"
      bodyKey="createShipment.reviewAndPay.editWarning.body"
      cancelKey="createShipment.reviewAndPay.editWarning.cancel"
      confirmKey="createShipment.reviewAndPay.editWarning.proceed"
      (cancelled)="cancelled.emit()"
      (confirmed)="confirmed.emit()"
    />
  `,
  styleUrl: './review-edit-warning-dialog.scss',
})
export class ReviewEditWarningDialog {
  readonly open = input(false);
  readonly cancelled = output<void>();
  readonly confirmed = output<void>();
}
